import React, { useContext, useState, useEffect } from "react";
import { StoreContext } from "../context/StoreContext";
// prettier-ignore
import { Button, Paper, Grid, Typography } from "@mui/material";
// prettier-ignore
import { useStyles } from "../styles/UserEditViewFormStyles";
import { usePromotionsStyles } from "../styles/PromotionsFormStyles";
import { ConsoleLogger } from "aws-amplify/utils";
import { graphql, graphqlOperation } from "../modules/AmplifyServices";
import { getCurrentUser } from "aws-amplify/auth";
import * as mutations from "../graphql/mutations";
import * as queries from "../graphql/queries";
import { ClientCreditCardUpdateForm } from "../components/stripe/ClientCreditCardUpdateForm";
import { execWrite } from "../modules/DBService";

export default function ClientBillingInfo(props) {
    const logger = new ConsoleLogger("ClientBillingInfo");

    const { state, dispatch, actions } = useContext(StoreContext);
    const [userId, setUserId] = useState("");
    const [openUpdateCCDialog, setOpenUpdateCCDialog] = useState(false);
    const [updateCCClientId, setUpdateCCClientId] = useState();
    const [stripeCustomerId, setStripeCustomerId] = useState();
    const [currentCardLast4, setCurrentCardLast4] = useState();
    const [reload, setReload] = useState(false);

    const classes = useStyles();
    const classesnew = usePromotionsStyles();

    //Fetching user info from cache.

    useEffect(() => {
        // if the source="user", set mode to edit
        const fetchData = async () => {
            await getUserData();
        };

        fetchData();
    }, []);

    useEffect(() => {
        // if the source="user", set mode to edit
        const fetchData = async () => {
            await getUserData();
        };
        if (reload) {
            setReload(false);
            fetchData();
        }
    }, [reload]);

    async function getUserData() {
        const user = await getCurrentUser();
        let userId = user.username;

        console.log("In getUserData", userId);
        setUserId(userId);
        if (!!userId) {
            const input = { id: userId };
            const result = await graphql(
                graphqlOperation(queries.getUser, input)
            );
            console.log("getUserData", result);
            if (result.data.getUser) {
                const clientProfile = await graphql(
                    graphqlOperation(queries.clientByUserId, {
                        userId: result.data.getUser.id
                    })
                );
                if (
                    clientProfile &&
                    clientProfile.data.clientByUserId.items.length
                ) {
                    const clientId =
                        clientProfile.data.clientByUserId.items[0].id;
                    setUpdateCCClientId(clientId);
                    setStripeCustomerId(
                        clientProfile.data.clientByUserId.items[0]
                            .stripeCustomerId
                    );
                    setCurrentCardLast4(
                        clientProfile.data.clientByUserId.items[0]
                            .defaultpartialcc
                    );
                } else {
                    //create client record (may be imported user)
                    const newClient = await createClientRecord(
                        result.data.getUser
                    );
                    setUpdateCCClientId(newClient.id);
                }
            }
        }
    }

    const createClientRecord = async (user) => {
        console.log("CREATEINGNEWCLIENT");
        const clientData = {
            userId: user.id,
            currency: user.company.currency ? user.company.currency : "CAD",
            companyId: user.companyId,
            clientUserId: user.id,
            clientCompanyId: user.companyId,
            accountbalance: 0.0
        };

        let client = await execWrite({
            opname: "createClient",
            op: mutations.createClient,
            input: clientData
        });

        if (client && client.error) {
            return {
                error: client.error
            };
        } else return client;
    };

    function showUpdateCCDialog() {
        // setUpdateCCClientId();
        setOpenUpdateCCDialog(true);
    }
    return (
        <>
            <Typography className={classes.title} variant="h4" noWrap>
                Add/Edit Credit Card
            </Typography>
            <ClientCreditCardUpdateForm
                show={openUpdateCCDialog}
                clientId={updateCCClientId}
                onClose={() => {
                    setOpenUpdateCCDialog(false);
                    setReload(true);
                }}
                updatedBySelf={true}
            />
            <Paper rounded="true" className={classes.root}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {currentCardLast4 ? (
                            <Typography
                                style={{ marginLeft: "8px" }}
                                variant="body2"
                            >
                                {`Your current credit card on file ends in ${currentCardLast4}.`}
                            </Typography>
                        ) : (
                            <Typography
                                style={{ marginLeft: "8px" }}
                                variant="body2"
                            >
                                {`Currently we don't have your credit card on file.`}
                            </Typography>
                        )}
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {currentCardLast4 ? (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={showUpdateCCDialog}
                                style={{ marginLeft: "8px", marginTop: "16px" }}
                            >
                                Update Credit Card
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={showUpdateCCDialog}
                                style={{ marginLeft: "8px", marginTop: "16px" }}
                            >
                                Add Credit Card
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
}
// TimeDisplayInfo: '{"dt_disp":"2024-11-27","dt_full_disp":"Wed, Nov 27 — 9:00 AM (EST)","dt_long_disp":"Wednesday, November 27, 2024","dtstamp_str":"2024-11-27T09:00:00-05:00","tm_st_disp":"9:00 AM","tm_et_disp":"10:00 AM","label":"09:00","tz":"America/Toronto","tz_abbr_disp":"EST","tz_gmtoff":"GMT-05:00","durationMins":60,"st_slot_disp":"Wed, Nov 27 at 9:00 AM EST","en_slot_disp":"Wed, Nov 27 at 10:00 AM EST"}';
// bookingBookedById: "5fe1d856-f537-4a3b-b8d0-3ff6f5335a36";
// bookingClientId: "9f20e27b-24a4-46a6-a342-f1de1659bcba";
// bookingCompanyId: "87d5b146-e678-4578-b351-1b697815ed61";
// bookingOrderId: "e9aee0aa-dba2-4534-9c09-9ea43f556941";
// bookingProviderId: "d53b44f7-ae3d-4587-a5fe-37b38643a57c";
// bookingServicetypeId: "7f283d96-84a8-4f83-83f8-52bfe7559fc3";
// clientId: "9f20e27b-24a4-46a6-a342-f1de1659bcba";
// companyId: "87d5b146-e678-4578-b351-1b697815ed61";
// desc: "Drums - 60 minute session";
// isVirtual: false;
// location: "Long & McQuade Musical Instruments, 66 Hearst Way, Kanata, ON K2L 2P4, Canada";
// manualBooking: true;
// minutes: 60;
// orderId: "e9aee0aa-dba2-4534-9c09-9ea43f556941";
// orderType: "SINGLE";
// providerId: "d53b44f7-ae3d-4587-a5fe-37b38643a57c";
// startdate: "2024-11-27T09:00:00-05:00";
// status: "SCHEDULED";
// timeblockid: "C-87d5b146-e678-4578-b351-1b697815ed61|P-d53b44f7-ae3d-4587-a5fe-37b38643a57c::BK|2024-11-27 09:00|CL-d3379430-308c-4f22-a2d2-6665d0cbf8b6|b1570ac5-c6c9-4893-a8f3-4717254d9197";
// timezone: "America/Toronto";

// {
//   "desc": "Drums - 60 minute session",
//   "startdate": "2024-11-28T09:00:00-08:00",
//   "minutes": 60,
//   "location": "Long & McQuade Musical Instruments, 66 Hearst Way, Kanata, ON K2L 2P4, Canada",
//   "companyId": "87d5b146-e678-4578-b351-1b697815ed61",
//   "bookingOrderId": "64979deb-cf98-4941-b161-5c0341928e21",
//   "orderId": "64979deb-cf98-4941-b161-5c0341928e21",
//   "orderType": "SINGLE",
//   "isVirtual": false,
//   "bookingServicetypeId": "7f283d96-84a8-4f83-83f8-52bfe7559fc3",
//   "bookingClientId": "9f20e27b-24a4-46a6-a342-f1de1659bcba",
//   "bookingCompanyId": "87d5b146-e678-4578-b351-1b697815ed61",
//   "timeblockid": "C-87d5b146-e678-4578-b351-1b697815ed61|P-d53b44f7-ae3d-4587-a5fe-37b38643a57c::BK|2024-11-28 09:00|CL-|d3379430-308c-4f22-a2d2-6665d0cbf8b6|512198e4-5166-4326-81f5-20e8b950dcca::BK|2024-11-28 09:00|CL-|d3379430-308c-4f22-a2d2-6665d0cbf8b6|512198e4-5166-4326-81f5-20e8b950dcca",
//   "clientId": "9f20e27b-24a4-46a6-a342-f1de1659bcba",
//   "status": "SCHEDULED",
//   "TimeDisplayInfo": "{\"dtstamp_str\":\"2024-11-28T17:00:00-08:00\",\"tz_abbr_disp\":\"PST\",\"tz_gmtoff\":\"GMT-08:00\",\"dt_disp\":\"2024-11-28\",\"dt_long_disp\":\"Thursday, November 28, 2024\",\"dt_full_disp\":\"Thu, Nov 28 — 5:00 PM (PST)\",\"en_slot_disp\":\"Thu, Nov 28 at 5:00 PM PST\",\"tm_st_disp\":\"5:00 PM\",\"tm_et_disp\":\"6:00 PM\",\"durationMins\":60}",
//   "manualBooking": true,
//   "bookingBookedById": "5fe1d856-f537-4a3b-b8d0-3ff6f5335a36"
// }
